import React from "react";
import tick from "../assests/images/tick.svg";
import { Link, useNavigate } from "react-router-dom";
import useResponsiveFlags from "../hooks/useResponsiveFlags";

export default function JobCreated(props) {
  const navigate = useNavigate();
  const { isDesktopLogin, isDesktop, isTablet, isTabletLogin } =
    useResponsiveFlags();
  return (
    <>
      <div className="flex-grow-1">
        <div>
          <div
            className="row ps-3 ps-lg-4 pe-3 pe-lg-4 pb-1"
            style={{ paddingTop: "24px" }}
          >
            <div className="col-12">
              <img src={tick} alt="" />
              <span className="form-label">
                &nbsp;Job Created Successfully!
              </span>
              <div
                className="mt-2 review-text sub-text"
                style={{
                  maxWidth: isDesktopLogin
                    ? "35%"
                    : isDesktop
                    ? "50%"
                    : isTabletLogin
                    ? "60%"
                    : isTablet
                    ? "70%"
                    : "100%",
                }}
              >
                <p>
                  Your job <strong>{props.data?.runName}</strong> has been created successfully.
                  Your job ID is {props.data.jobid}. You will receive an email
                  when your job is done.
                </p>
                <p>
                  You can also check the status of your job at anytime on{" "}
                  <Link to="/dashboard">your dashboard.</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="d-flex justify-content-between flex-column flex-sm-row ps-3 ps-lg-4 pe-3 pe-lg-4"
        style={{
          paddingTop: "22px ",
          paddingBottom: "19px",
          borderTop: "1px solid #EEEEEE",
        }}
      >
        <button
          type="button"
          onClick={() => navigate("/")}
          className="cancel-btn me-0 mb-3 mb-sm-0"
        >
          Go to Dashboard
        </button>
        <button
          type="button"
          onClick={() => {
            props.resetState();
          }}
          className="cancel-btn me-0"
        >
          Start Another Job
        </button>
      </div>
    </>
  );
}
